import { useAtomValue, useSetAtom } from "jotai";
import { modelDataAtom } from "../../atoms";
import _ from "lodash";
import apiAgent from "../../api/apiAgent";
import { tMsg } from "../ToastNotifications";
import { publishGroups } from "./publishConfig";
import { updatePublishTimes } from "./utils";
import { Dispatch, SetStateAction } from "react";
import { screenTypesArray } from "../../utils/slideTemplateAllocation";

/**
 * Get and publish the models
 * @param models string of models to publish
 * @returns
 */
const useWorksPhotosPublisher = (
  setPublishing: Dispatch<SetStateAction<boolean>>
) => {
  // Step 1: get model data from locally stored data atom
  // const modelData = useAtomValue(modelDataAtom);
  const { atom } = publishGroups.schoolphotos;
  const setPublishTimes = useSetAtom(atom);

  const callModels = ["schoolphotos", "studentworks"];

  const allRequests = callModels.map((model) =>
    apiAgent.DataType.getAll(model)
  );

  // Return requesting function
  return async () => {
    try {
      setPublishing(true);
      const results = await Promise.all(allRequests);
      const data = callModels.reduce((obj, model, index) => {
        const sortData = results[index].data;
        sortData.sort((a: any, b: any) => a.sortId - b.sortId);
        return {
          ...obj,
          [model]: sortData,
        };
      }, {});

      const filepathsJson = {
        [`endpoints/schoolphotosAndStudentwork.json`]: data,
      };

      console.log("to publish", filepathsJson);
      const response = await apiAgent.Models.publish({ filepathsJson });

      if (response.status === 200) {
        tMsg.success("Changes have been pushed");
        updatePublishTimes("schoolphotos", setPublishTimes);
      } else throw response.statusText;
    } catch (err) {
      tMsg.error("Error pushing. See Console for details.");
      console.log(err);
    } finally {
      setPublishing(false);
    }
  };
};

export { useWorksPhotosPublisher };
